import React from 'react';
import Backdrop from './backdrop.component';

const Modal = ({ show, children, size = "lg", backDrop = true }) => {
    return (
      <>
        { backDrop ? <Backdrop show={show} /> : null }
          <div
          className={`ModalCustom modal-${size}`}
            style={{
                transform: show ? 'translateY(0)' : 'translateY(-100vh)',
                opacity: show ? 1 : 0
            }}
          >
            {children}
          </div>
      </>
    );
};


export default Modal;